import type { FormEmbedField } from "./types.js";

export function usesCheckboxOptions(field: Pick<FormEmbedField, "type" | "options">): boolean {
  return field.type === "pillCheckbox" || (field.type === "checkbox" && !!field.options?.length);
}
